import { InjectionToken, provideAppInitializer, inject } from "@angular/core"
import { IdSystemConfig, IdSystemService, IdSystemTokenInterceptorConfig } from "."

export const ID_SYSTEM_CONFIG = new InjectionToken<IdSystemConfig>('IdSystemConfig')
export const ID_SYSTEM_TOKEN_INTERCEPTOR_CONFIG = new InjectionToken<IdSystemTokenInterceptorConfig[]>('IdSystemTokenInterceptorConfig')

export function provideIdSystem(config: IdSystemConfig) {
  const tokenInterceptorConfig: IdSystemTokenInterceptorConfig[] = []

  if (Array.isArray(config.tokenInterceptor)) {
    tokenInterceptorConfig.push(...config.tokenInterceptor)
  } else if (config.tokenInterceptor) {
    tokenInterceptorConfig.push(config.tokenInterceptor)
  }

  // Добавляем правило для перехвата пользовательских запросов в ID систему
  tokenInterceptorConfig.push({
    urlPattern: `${config.apiUrl}/user/`,
    headerName: 'Authorization',
    tokenType: 'Bearer'
  })

  return [
    {
      provide: ID_SYSTEM_CONFIG,
      useValue: config
    },
    {
      provide: ID_SYSTEM_TOKEN_INTERCEPTOR_CONFIG,
      useValue: tokenInterceptorConfig
    },
    provideAppInitializer(() => inject(IdSystemService).init()),
  ]
}
